import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Tabs,
  Button,
  Tooltip,
  message,
  Icon,
  Table,
  Typography,
  Menu,
  Input,
  Dropdown,
} from "antd";
const { TabPane } = Tabs;
import {
  LeftOutlined,
  MessageOutlined,
  UserOutlined,
  HistoryOutlined,
} from "@ant-design/icons";
import CallerLogs from "./CallerLogs";
import AutoCallerModal from "./AutoCallerModal";
import CallerTemplate from "./CallerTemplate";
import { platformApi } from "../../../api";
const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

const AutoCaller = () => {
  const history = useHistory();
  
  const [addFlag, setAddFlag] = useState(false);
  const [templates,setTemplates] = useState([]);
  const [selectedData,setSelectedData] = useState();
  const [isModify,setIsModify] = useState(false);

  const getTemplates = () => {
    platformApi.get("/api/autocall").then((response) => {
      setTemplates(response.data.templates)
    });
  }

  const openModal = (id,modify) => {
    setAddFlag(true);
    setSelectedData(templates.filter((obj)=>obj.id===id));
    setIsModify(modify);
  }

  return (
    <>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          <Tooltip placement="topLeft" title={"Back to Company Master"}>
            <Button
              style={{ margin: "0 20px" }}
              onClick={() => history.push("/autoadmin/company")}
            >
              <LeftOutlined />
            </Button>
          </Tooltip>
          Autocaller
        </Title>
        {/* <Button
          onClick={() => setAddFlag(true)}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
        >
          Add Template
        </Button> */}
      </div>
      <Tabs defaultActiveKey="1">
        <TabPane
          tab={
            <span>
              <MessageOutlined />
              Caller Templates
            </span>
          }
          key="1"
        >
          <CallerTemplate getTemplates={getTemplates} templates={templates} openModal={openModal} />
        </TabPane>
        <TabPane
          tab={
            <span>
              <HistoryOutlined />
              Caller Logs
            </span>
          }
          key="2"
        >
          <CallerLogs />
        </TabPane>
      </Tabs>

      <AutoCallerModal
        selectedData={selectedData}
        open={addFlag}
        close={() => {
          setAddFlag(false);
          setSelectedData(null);
          setIsModify(false);
        }}
        isModify={isModify}
        getTemplates={getTemplates}
      />
    </>
  );
};

export default AutoCaller;
